import { useAuth } from "@/_core/hooks/useAuth";
import { Link, useLocation } from "wouter";
import { Home, Search, Heart, User, LogIn } from "lucide-react";

export default function MobileBottomNav() {
  const { isAuthenticated } = useAuth();
  const [location] = useLocation();

  // Hide on vendor dashboard, vendor profiles (singular + plural), admin, checkout,
  // and product detail (which has its own sticky bar)
  if (
    location.startsWith("/vendor/") ||
    location.startsWith("/vendors/") ||
    location.startsWith("/admin") ||
    location.startsWith("/checkout") ||
    /^\/products\/\d/.test(location)
  ) {
    return null;
  }

  const tabs = [
    { href: "/", icon: Home, label: "Home", active: location === "/" },
    {
      href: "/products",
      icon: Search,
      label: "Search",
      active: location === "/products" || location.startsWith("/products?"),
    },
    {
      href: "/wishlist",
      icon: Heart,
      label: "Saved",
      active: location === "/wishlist",
    },
    isAuthenticated
      ? {
          href: "/orders",
          icon: User,
          label: "Account",
          active: location === "/orders" || location === "/notifications",
        }
      : {
          href: "/sign-in",
          icon: LogIn,
          label: "Sign In",
          active: location === "/sign-in" || location === "/auth",
        },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-background/95 backdrop-blur-lg border-t border-border/20 safe-area-pb"
      style={{ willChange: "transform" }}
      aria-label="Bottom navigation"
    >
      <div className="flex items-center justify-around h-14 max-w-lg mx-auto">
        {tabs.map(({ href, icon: Icon, label, active }) => (
          <Link
            key={href}
            href={href}
            aria-label={label}
            aria-current={active ? "page" : undefined}
            className={`flex flex-col items-center justify-center gap-0.5 min-w-[64px] min-h-[44px] no-underline transition-colors ${
              active
                ? "text-primary"
                : "text-muted-foreground/60 hover:text-foreground"
            }`}
          >
            <Icon className="h-5 w-5" strokeWidth={active ? 2.5 : 2} />
            <span
              className={`text-xs tracking-wide ${active ? "font-semibold" : "font-medium"}`}
            >
              {label}
            </span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
